import { useEffect } from "react"
import Turnstile, { useTurnstile } from "react-turnstile"



export const TurnstileComponent = ({ getToken, reset }) => {
    const turnstile = useTurnstile()

    const sendToken = (token) => {
        getToken(token)
    }

    useEffect(() => {
        if (reset) {
            turnstile.reset()
        }
    }, [reset])

    return (
        process.env.NODE_ENV !== 'development' &&
        <Turnstile
            sitekey={"0x4AAAAAAAFequHY6LJ6imuP"}
            onVerify={(token) => sendToken(token)}
            fixedSize={true}
        />
    )
} 